import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TrendListItem from './TrendListItem';

export default class TrendListItems extends Component {
  constructor(props) {
    super(props);
  }

  handleSelection = (selectedElementId, clearExisting, shiftKey) => {
    this.props.handleSelection(selectedElementId, clearExisting, shiftKey);
  };

  render() {
    const renderList = () =>
      this.props.items.map(item => {
        item.selected =
          this.props.selectedItems &&
          this.props.selectedItems.indexOf(item.id) >= 0;
        return (
          <TrendListItem
            key={item.id}
            {...item}
            handleSelection={this.handleSelection}
          />
        );
      });

    return (
      <div className="multi-select-list">
        <ul
          className="vertical dropdown menu user-select-none"
          data-dropdown-menu
        >
          {renderList()}
        </ul>
      </div>
    );
  }
}

TrendListItems.propTypes = {
  handleSelection: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.arrayOf(PropTypes.object),
};
